import React, { memo } from 'react'
import Box from '@mui/material/Box'
import { FormattedMessage } from 'react-intl'
import { Typography } from '@mui/material'
// import clsx from 'clsx'
import sx from './styles'

const DicountBanner = (props) => {
  const {
    text,
    position = 'absolute',
    top = '0px',
    right = '0px',
    left = '0px',
    marginBottom = '4px',
    zIndex = 0,
    bgcolor,
    sxProps = {},
    textBlock,
    // Elemento opcional que se pinta junto al texto (ej. la flama animada).
    adornment = null,
  } = props

  return (
    <Box
      sx={sx.hasDiscountContainer}
      style={{
        position: `${position}`,
        top: `${top}`,
        right: `${right}`,
        left: `${left}`,
        zIndex: `${zIndex}`,
        marginBottom: `${marginBottom}`,
      }}
    >

      <Typography
        variant="quote"
        sx={{
          ...sx.hasDiscountText,
          ...sxProps,
          backgroundColor: `${bgcolor}`,
          color: `${text === 'VEHICLE_STATUS_COMMING_SOON' ? '#FFFFFF' : '#000000'}`,
        }}
        // className={clsx({
        //   blackColor: text === 'VEHICLE_STATUS_GO_BACK',
        // })}
      >
        {text && (
          <FormattedMessage id={text} />
        )}

        {textBlock && (
          textBlock
        )}
      </Typography>

      {adornment}

    </Box>
  )
}

export default memo(DicountBanner)
